// Vendor libraries
import { createSelector } from '@ngrx/store';
const getFetchRequest = (state) => state.fetchRequest;
const getItemsMap = (state) => state.itemsMap;
const getSecurityObject = (state) => state.securityObject;
export const isFinishedFetchingWatchlists = createSelector(getFetchRequest, (fetchRequest) => {
    if (!fetchRequest) {
        return false;
    }
    return fetchRequest.status === 'success';
});
export function watchlistSortFunction(a, b) {
    const nameA = a.name.toLowerCase();
    const nameB = b.name.toLowerCase();
    if (nameA < nameB) {
        return -1;
    } // nameA comes first
    if (nameA > nameB) {
        return 1;
    } // nameB comes first
    return 0; // nameA === nameB
}
export function getGroupedWatchlistsCombiner(fetchRequest, itemsMap, securityObject) {
    const containingWatchlists = [];
    const excludingWatchlists = [];
    if (!securityObject || fetchRequest.status !== 'success') {
        return {
            containingWatchlists,
            excludingWatchlists,
        };
    }
    const watchlistsOfType = itemsMap[securityObject.watchlist_type] ? itemsMap[securityObject.watchlist_type] : [];
    watchlistsOfType.forEach((watchlist) => {
        const securityIds = watchlist.watchlistItems.map((item) => item.securityId);
        if (securityIds.includes(securityObject.security_id)) {
            containingWatchlists.push(watchlist);
        }
        else {
            excludingWatchlists.push(watchlist);
        }
    });
    containingWatchlists.sort(watchlistSortFunction);
    excludingWatchlists.sort(watchlistSortFunction);
    return {
        containingWatchlists,
        excludingWatchlists,
    };
}
export const getGroupedWatchlists = createSelector(getFetchRequest, getItemsMap, getSecurityObject, (fetchRequest, itemsMap, securityObject) => {
    return getGroupedWatchlistsCombiner(fetchRequest, itemsMap, securityObject);
});
